import isNil from 'lodash/isNil';

export function sanitizeData (obj: object) {
	const result = {};

	Object.keys(obj).forEach((key) => {
		if (!isNil(obj[key as keyof typeof obj])) {
			result[key as keyof typeof obj] = obj[key as keyof typeof obj];
		}
	});

	return result;
}

export function isLink (str: string): boolean {
	if (str.startsWith('https://' || 'https://')) {
		return true;
	} else {
		return false;
	}
}
